import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { HeaderState } from '../../../types/appState';
import type { Agent } from '../../../types/domain';
import { getWidgetRuntimeData } from '../thunks/widgetRuntime.thunk';
import { chatActions } from './chat';

const initialState: HeaderState = {
  isEnabled: false,
  announcement: undefined,
  onlineAgents: [],
  hideStatusBanner: false,
};

export const headerSlice = createSlice({
  name: 'header',
  initialState,
  reducers: {
    enableButton: (state) => {
      state.isEnabled = true;
    },
    hideAlert: (state) => {
      state.announcement = undefined;
    },
    agentJoined: (state, action: PayloadAction<Agent>) => {
      const index = state.onlineAgents.findIndex((agent) => {
        return agent.id === action.payload.id;
      });
      if (index > -1) {
        return;
      }
      state.onlineAgents.push(action.payload);
    },
    agentLeft: (state, action: PayloadAction<Agent>) => {
      state.onlineAgents = state.onlineAgents.filter((agent) => {
        return agent.id !== action.payload.id;
      });
    },
    // will be moved under chat actions and "consumed" under extraReducers
    changeChatMode: (state, action: PayloadAction<boolean>) => {
      if (action.payload) {
        return;
      }
      state.onlineAgents = [];
    },
    resetStatusBanner: (state) => {
      state.hideStatusBanner = true;
      state.statusBanner = undefined;
    },
    setStatusBanner: (state, action: PayloadAction<HeaderState['statusBanner']>) => {
      state.statusBanner = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(chatActions.reset, (state) => {
      state.isEnabled = false;
      state.onlineAgents = [];
    });
    builder.addCase(getWidgetRuntimeData.fulfilled, (state, action) => {
      state.statusBanner = action.payload.header?.statusBanner;
    });
  },
});

export const headerActions = headerSlice.actions;
